import { render, staticRenderFns } from "./Approvers.vue?vue&type=template&id=1da33da8&scoped=true"
import script from "./Approvers.vue?vue&type=script&lang=js"
export * from "./Approvers.vue?vue&type=script&lang=js"
import style0 from "./Approvers.vue?vue&type=style&index=0&id=1da33da8&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1da33da8",
  null
  
)

export default component.exports